/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const ASSETS = [
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/1_1_Blue_Label_Legendary.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/Johnnie_Balance_book.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/Johnnie.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/JW_Draw.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/9_Black_Dog.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/9_1_Black_Dog_18_Years.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/8_MCDOWELLS-NO.1-RESERVE-WHISKY.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/7_SIGNATURE-RARE-AGED-WHISKY.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/5_Tanqueray_Gin.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/5_Bottles_3.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/5_Bottles_2.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/4_vat_69_black.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/4_Yaari.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/4_1_vat_69_black.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/3_Yaari.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/3_Smirnoff.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/3_1_Smirnoff.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/2_Yaari.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/2_ANTIQUITY-BLUE-ULTRA-PREMIUM-WHISKY.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/2_1_ANTIQUITY-BLUE-ULTRA-PREMIUM-WHISKY.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/1_Yaari.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/1_Blue_Label_Legendary.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/1_1_Blue_Label_Legendary.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/12_baileys-liqueur.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/11_Directors-Special-Whisky.dzi",
    "https://diageo-demo-nft-assets.s3.ap-south-1.amazonaws.com/10_Black_And_White.dzi",
];

export const ASSET_MAPPER = [
    {
        idx: 1,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 42,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 44,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 45,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 8,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 8,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 7,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 5,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 6,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 24,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 25,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 12,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 34,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 12,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 33,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 11,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 11,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 31,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 2,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 2,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 31,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 1,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 1,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 9,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 10,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
    {
        idx: 4,
        scAddress: "0xf5ef2fda276a4b18fc32fe3a2597c2dfd4a8fbf1"
    },
];